import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-add-container',
  templateUrl: './add-container.component.html',
  styleUrls: ['./add-container.component.css']
})
export class AddContainerComponent implements OnInit {

  @Input() array: any;
  @Input() index: number;
  @Input() pop: any;

  constructor() { }

  ngOnInit() {
  }


  add(row) {
    this.array.splice(this.index, 0, row);
    if (this.pop) {
      this.pop.hide()
    }

  }
}
